module.exports = __webpack_public_path__ + "img/expereince.3a85ceca.svg";